module.exports = __webpack_public_path__ + "img/sjwk.3c934a32.svg";